import React, { useState, useEffect } from 'react';

interface BudgetStepProps {
  recordId: number; // ID of the record to edit
  handleClose: () => void; // Close the popup
  onUpdate: () => void; // Callback to refresh the data after update
}

interface FormData {
  campaignName: string;
  cost: string;
  noDailyLimit: string;
  [key: string]: string;
}

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ;
   

const BudgetStepPopup: React.FC<BudgetStepProps> = ({
  recordId,
  handleClose,
  onUpdate,
}) => {
  const [formData, setFormData] = useState<FormData>({
    campaignName: '',
    cost: '',
    noDailyLimit: '',
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      if (!recordId) {
        console.error("No recordId provided");
        return;
      }
      try {
        const response = await fetch(`${API_BASE_URL}/api/budget/getBudgetById/${recordId}`);
        if (!response.ok) {
          throw new Error(`Failed to fetch data: ${response.statusText}`);
        }
        const data = await response.json();
        setFormData({
          campaignName: data.campaign_name || '',
          cost: data.cost || '',
          noDailyLimit: data.daily_cap ? 'Set Daily Ad Budget' : 'No Daily Limit',
        });
      } catch (err) {
        console.error("Error fetching data:", err);
        setError("Failed to load campaign data. Please try again.");
      }
    };
  
    fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recordId]);
  

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev: FormData) => ({ ...prev, [name]: value }));
 
  };

  const handleUpdate = async () => {
    console.log("Fetching data for recordId:", recordId);
    console.log("Updated formData:", formData);
    if (!recordId) {
      console.error('No record ID provided');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await fetch(`${API_BASE_URL}/api/budget//updateBudget/${recordId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error(`Failed to update record: ${response.statusText}`);
      }

      alert("Record updated successfully!");
      onUpdate(); // Refresh parent data
      handleClose(); // Close the popup
    } catch (err: any) {
      console.error("Error updating record:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div style={{ marginLeft: '30px' }}>
      <div style={{display:'flex'}}>
        <p >Campaign: </p>
        <p style={{fontWeight:'500', marginLeft:'4px'}}>{formData.campaignName}</p>
      </div>

      <div>
        <h4>Daily Budget</h4>
        <p style={{marginTop:'-14px'}}>Daily Ad Budget for Ad Identifier: <b>{formData.campaignName}</b></p>
        <p style={{ lineHeight: '20px', marginTop:'-10px' }}>
          By setting the Daily Ad Budget, you can control your daily spending for this ad. <br />
          BidVertiser displays your ad as often as possible while staying within your Daily Ad Budget. <br />
          When the limit is reached, your ad will stop showing for that day.
        </p>
      </div>

      {/* Radio button: No Daily Limit */}
      <label style={{ display: 'block', marginBottom: '10px', fontSize:'12px' }}>
        <input
          type="radio"
          name="noDailyLimit"
          value="No Daily Limit"
          checked={formData.noDailyLimit === 'No Daily Limit'}
          onChange={handleInputChange}
        />
        No Daily Limit
      </label>

      {/* Radio button: Set Daily Ad Budget */}
      <label style={{ display: 'block', marginBottom: '10px', fontSize:'12px'  }}>
        <input
          type="radio"
          name="noDailyLimit"
          value="Set Daily Ad Budget"
          checked={formData.noDailyLimit === 'Set Daily Ad Budget'}
          onChange={handleInputChange}
        />
        Set Daily Ad Budget: $
        <input
          type="number"
          name="cost"
          value={formData.noDailyLimit === 'No Daily Limit' ? '' : formData.cost}
          onChange={(e) =>
            handleInputChange({ ...e, target: { ...e.target, name: 'cost' } })
          }
          min={5}
          placeholder="5"
          style={{
            marginLeft: '10px',
            width: '100px',
            padding: '5px',
            borderRadius: '4px',
            border: '1px solid #ccc',
            fontSize:'12px' 
          }}
          disabled={formData.noDailyLimit === 'No Daily Limit'}
        />
        <span style={{ marginLeft: '10px' }}>(minimum $5)</span>
      </label>

      <button
        style={{ padding: '10px', backgroundColor: '#1A3F66', color: 'white', borderRadius: "2px" }}
        type="button"
        onClick={handleUpdate}
      >
        Update
      </button>

      {error && <div style={{ color: "red" }}>Error: {error}</div>}
    </div>
  );
};

export default BudgetStepPopup;
